import type { DateFormatId, TimeFormatId } from './types';
import { DATE_FORMATS, byId } from './catalog';
import { pad, parseDate } from '../lib/util';

export function fmtDate(iso: string | undefined, f: DateFormatId | undefined) {
  const p = parseDate(iso);
  return p ? byId(DATE_FORMATS, f).f(p) : '';
}

export function fmtTime(hm: string | undefined, f: TimeFormatId | undefined = '12', short = false) {
  const m = /^(\d{1,2}):(\d{2})/.exec(hm || '');
  if (!m) return '';
  const h = +m[1], mi = m[2];
  if (f === '24') return pad(h) + ':' + mi;
  const ap = h < 12 ? 'am' : 'pm', h12 = h % 12 || 12;
  const core = short && mi === '00' ? String(h12) : `${h12}:${mi}`;
  return f === '12U' ? `${core} ${ap.toUpperCase()}` : core + ap;
}

/** Splits text into paragraphs on blank lines; single line breaks are kept inside a paragraph. */
export function paragraphs(text: string | undefined) {
  return String(text || '').trim().split(/\n\s*\n/).filter(Boolean);
}
